module.exports = __webpack_public_path__ + "static/m_solution10-9331df84654c86daa5e9dc18d48905a9.png";